import React from 'react'
import CtaCard from '../../cards/CtaCard'

const TransformMarketing = () => {
    return (
        <section className='bg-brandGradient py-[120px] md:py-40 lg px-8 md:px-[68px] lg:px-[90px] xl:px-32'>
            <CtaCard
                header='Ready to Transform Your Marketing?'
                text='Step into the future with Eulerity and witness your marketing evolve. Schedule a demo today and see our technology in action.'
                btnText='Schedule a Demo'
                btnLink='/contact-us'
            />
        </section>
    )
}

export default TransformMarketing